import { render, staticRenderFns } from "./index.vue?vue&type=template&id=75c6921c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c6921c')) {
      api.createRecord('75c6921c', component.options)
    } else {
      api.reload('75c6921c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=75c6921c", function () {
      api.rerender('75c6921c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/index.vue"
export default component.exports